(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    if (!window.__corailImageHoverSwapBound) {
  window.__corailImageHoverSwapBound = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !window.matchMedia('(hover: none)').matches) return;

    const wrapper = event.target.closest('.hover-swap.is-enabled[data-hover-swap-tap-enabled="true"]');
    wrapper?.classList.toggle('is-toggled');
  });
}
  } catch(e) { console.error(e); }
})();

})();
